<template>
  <div>
    <div class="mg-y-10 tx-18" style="color: #21242e">
      Шинжээчээр ажиллах төслүүд
    </div>
    <router-link v-if="list.length == 0" :to="{ name: 'home' }">
      <div class="bg-white rounded-20 mg-t-50 text-center pd-10">
        <div class="" style="margin-top: -50px">
          <img :src="`${myResBaseUrl}v4-assets/img2.png`" />
        </div>
        <div class="mg-t-10 text-muted">Сайн байна уу</div>
        <h6>
          Танд одоогоор шинжээчээр ажиллах төсөл алга байна. Та хувийн мэдээллээ
          шинэчилж түлхүүр үгээ илүү нарийвчлалтай тохируулах бол энд дарна уу
        </h6>
        <button
          type="button"
          class="btn btn-primary btn-icon mg-t-10 rounded-20"
          style="margin-bottom: -25px"
        >
          <feather type="arrow-right" :width="32" :height="32"></feather>
        </button>
      </div>
    </router-link>

    <div v-else class="card mg-b-10" v-for="(l, i) in list" :key="i">
      <div class="card-header">{{ l.zarTask.type.name }}</div>
      <div class="card-body pd-0-f">
        <ul class="mg-b-0">
          <li class="list-group-item d-flex align-items-center bd-0 bd-b">
            <div class="">
              <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">Төслийн нэр</h6>
              <span class="d-block tx-11 text-muted">{{
                l.projectTask.task
              }}</span>
            </div>
          </li>
          <!-- <li class="list-group-item d-flex align-items-center bd-0 bd-b">
            <div class="">
              <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">Төслийн зар</h6>
              <span class="d-block tx-11 text-muted">{{ l.zarTask.task }}</span>
            </div>
          </li> -->
          <li
            class="list-group-item d-flex align-items- center bd-0 bd-b"
            v-if="
              l.companyTask != null &&
                l.companyTask.name != undefined &&
                l.companyTask.name != null
            "
          >
            <div class="">
              <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">Гүйцэтгэгч</h6>
              <span class="d-block tx-11 text-muted">{{
                l.companyTask.name
              }}</span>
            </div>
          </li>
          <li class="list-group-item d-flex align-items-center bd-0 bd-b">
            <div class="">
              <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">
                Үнэлгээ өгөх хугацаа
              </h6>
              <span class="d-block tx-11 text-muted"
                >{{ l.zarTask.d3 | moment("YYYY.MM.DD") }} -
                {{ l.zarTask.d4 | moment("YYYY.MM.DD") }}</span
              >
            </div>
          </li>
          <li class="list-group-item d-flex align-items-center bd-0 bd-b">
            <div class="">
              <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">
                Миний өгсөн оноо
              </h6>
              <span class="d-block tx-11 text-muted">{{
                l.point.myPoint
              }}</span>
            </div>
          </li>
          <li class="list-group-item d-flex align-items-center bd-0 bd-b">
            <div class="">
              <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">
                Дэмжсэнд тооцох босго оноо
              </h6>
              <span class="d-block tx-11 text-muted">{{
                l.point.maxPoint
              }}</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="card-footer d-flex align-items-center">
        <button @click="setMark(l.projectTask.id)" class="btn btn-info btn-xs">
          үнэлгээ өгөх
        </button>
        <div
          class=" mg-l-auto text-muted"
          v-if="l.point != undefined && l.point != null"
        >
          {{ l.point.myPoint }}/{{ l.point.maxPoint }}
          <feather
            v-if="l.point.isDone"
            type="check-circle"
            class="text-success mg-l-5"
          ></feather>
          <feather v-else type="circle" class="mg-l-5"></feather>
        </div>
      </div>
    </div>

    <b-modal
      style="z-index: 5"
      id="markObj"
      v-model="markObj.modal"
      body-class="test-modal-body bg-light ht-100v"
      dialog-class="test-modal-dialog"
      centered
      scrollable
      title="Үнэлгээ өгөх"
    >
      <div class="ht-100v">
        <div class="d-flex">
          <div class="wd-50p pd-20">
            <task-info
              class="wd-100p bg-white rounded-20 bd pd-20"
              :fields="markObj.fields"
              :obj="{ data: { task: markObj.task } }"
              :loaded="markObj.fetched"
              :boxId="0"
              :parentTask="null"
              @on-attach="showFile"
            />
          </div>
          <div class="wd-50p pd-20" v-if="markObj.fetched">
            <div class="wd-100p bg-white rounded-20 bd pd-20">
              <table class="table table-bordered table-striped wd-100p">
                <thead class="font-weight-bold">
                  <th>Шалгуур үзүүлэлтүүд</th>
                  <th class="wd-50">Таны үнэлгээ</th>
                  <th class="wd-50">Боломжит хамгийн их оноо</th>
                </thead>
                <tbody>
                  <template v-for="(p, i) in pointsDta.points">
                    <tr :key="`tr1_${i}`">
                      <td>{{ p.shalguurName }}</td>
                      <td style="width: 50px" class="wd-50">
                        <InputNumber
                          :min="0"
                          :max="p.maxPoint"
                          v-model="p.point"
                        />
                      </td>
                      <td class="wd-50">{{ p.maxPoint }}</td>
                    </tr>
                    <tr :key="`tr2_${i}`">
                      <td colspan="2">
                        <textarea
                          v-model="p.desc"
                          class="form-control"
                          placeholder="Тайлбар бичнэ үү"
                        ></textarea>
                      </td>
                      <td>
                        <b-button
                          variant="warning"
                          size="sm"
                          class="float-right"
                          @click="postPoints(false)"
                        >
                          хадгалах
                        </b-button>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>

              <div>
                Үнэлгээ өгсөн тайлбар буюу дүгнэлт энд бичнэ үү
                <textarea
                  class="form-control"
                  rows="6"
                  v-model="pointsDta.execution"
                ></textarea>

                <div
                  v-if="markObj.fetched"
                  :class="
                    `alert alert-${
                      pointsDta.points.reduce(
                        (sum, st) => sum + parseInt(st.point),
                        0
                      ) >= 27
                        ? 'success'
                        : 'warning'
                    } mg-t-10 mg-b-0`
                  "
                  role="alert"
                >
                  <h6 class="alert-heading">Таны өгсөн нийт оноо</h6>

                  <p>
                    <b>
                      {{
                        pointsDta.points.reduce(
                          (sum, st) => sum + parseInt(st.point),
                          0
                        )
                      }}</b
                    >
                  </p>
                  <hr />
                  <p class="mb-0">
                    Уг төсөлд
                    {{
                      getDemjsenPoint(markObj.task.organizationTask.locTypeId)
                    }}
                    ба түүнээс дээш оноо өгсөн бол дэмжсэнд тооцно. Түүнээс доош
                    бол дэмжээгүйд тооцно.
                  </p>
                </div>
              </div>
            </div>
            <!-- {{ markObj.task.b.length }}
                    <div v-for="(b, i) in markObj.task.b" :key="i">{{ b.otCompName }}</div> -->
            <!-- <h1>энд box зурах гээд bug тай үлдээсэн :D</h1> -->
            <div v-for="(b, i) in markObj.task.b" :key="i">
              <loader
                :ref="`ldr_box_${b.id}`"
                :box="b"
                :prms="{ boxChooser: false }"
                :detailSettingProp="{
                  boxSetting: {
                    listSetting: { height: 0 },
                    hideToolbar: true,
                    hideEmptyTemplate: true,
                    autoHeight: true,
                    hideFooter: true,
                  },
                }"
                @on-attach="showFile($event)"
                @on-detail="showDetail"
                @load-box="loadBoxData"
              />
            </div>
          </div>
        </div>
      </div>
      <template #modal-footer>
        <div class="w-100">
          <!-- <p class="float-left">энд тайлбар бичнэ</p> -->
          <b-button
            variant="primary"
            size="sm"
            class="float-right"
            @click="postPoints(true)"
          >
            Үр дүнг хадгалах
          </b-button>
        </div>
      </template>
    </b-modal>

    <b-modal title="АШИГ СОНИРХЛЫН МЭДЭГДЭЛ" v-model="agrmnt.modal" hide-footer>
      <div class="alert alert-warning" role="alert">
        Та доорхи маягтын татан авч бөглөөд ашиг сонирхлын зөрчилгүй эсвэл
        зөрчил үүссэн тухай мэдээллийг илгээснээр үнэлгээ өгөх эрх нээгдэнэ.
      </div>
      <a @click="dwnldM" class="btn btn-block btn-primary mg-t-10"
        >Маягт татах</a
      >

      <div class="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
        <div class="form-group">
          <label
            class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03"
            >Бөглөсөн маягт хуудас 1</label
          >
          <simple-uploader
            v-model="ashigSonirhol.attachmentId"
            :propObjectTypeId="6"
            @on-success="fileUploaded"
          >
            <div slot="trigger">
              <div
                v-if="ashigSonirhol.attachmentId == null"
                class="btn btn-primary"
                style="height: 38px"
              >
                <label style="margin-btoom: 0" class="custom-file-label"
                  >Файл сонгоогүй байна</label
                >
              </div>
              <div
                v-else
                class="btn d-flex align-items-center btn-outline-success btn-block btn-xs"
                style="height: 38px"
                @click.prevent.stop="ashigSonirhol.attachmentId = null"
              >
                <span class="mg-l-auto d-flex align-items-center text-danger">
                  <span style="font-weight: 700">{{
                    ashigSonirhol.attachmentTitle
                  }}</span>
                  <span style="margin-left: 260px;">
                    Болих
                    <feather type="x" class="mg-l-5"></feather>
                  </span>
                </span>
              </div>
            </div>
          </simple-uploader>
          <label
            class="tx-10 tx-uppercase tx-medium tx-spacing-1 mg-b-5 tx-color-03"
            >Бөглөсөн маягт хуудас 2</label
          >
          <simple-uploader
            v-model="ashigSonirhol.secondAttachmentId"
            :propObjectTypeId="6"
            @on-success="fileUploaded2"
          >
            <div slot="trigger">
              <div
                v-if="ashigSonirhol.secondAttachmentId == null"
                class="btn btn-primary"
                style="height: 38px"
              >
                <label style="margin-btoom: 0" class="custom-file-label"
                  >Файл сонгоогүй байна</label
                >
              </div>
              <div
                v-else
                class="btn d-flex align-items-center btn-outline-success btn-block btn-xs"
                style="height: 38px"
                @click.prevent.stop="ashigSonirhol.secondAttachmentId = null"
              >
                <span class="mg-l-auto d-flex align-items-center text-danger">
                  <span style="font-weight: 700">{{
                    ashigSonirhol.secondAttachmentTitle
                  }}</span>
                  <span style="margin-left: 260px;">
                    Болих
                    <feather type="x" class="mg-l-5"></feather>
                  </span>
                </span>
              </div>
            </div>
          </simple-uploader>
        </div>
      </div>
      <!-- modal-body -->
      <div class="modal-footer pd-x-20 pd-y-15">
        <button
          @click="agrmnt.modal = false"
          type="button"
          class="btn btn-white"
          data-dismiss="modal"
        >
          Болих
        </button>
        <button @click="postAgrmnt" type="button" class="btn btn-primary">
          Илгээх
        </button>
      </div>
    </b-modal>

    <b-modal title="Банкны мэдээлэл" v-model="bankAccount.modal" hide-footer>
      <div class="alert alert-warning" role="alert">
        Та банкны мэдээллээ илгээнэ үү.
      </div>
      <!-- <a @click="dwnldM" class="btn btn-block btn-primary mg-t-10"
        >Маягт татах</a
      > -->

      <div class="modal-body pd-sm-t-30 pd-sm-b-40 pd-sm-x-30">
        <div class="form-group">
          <table class="table">
            <tbody>
              <tr>
                <th scope="row" class="text-right">
                  Регистрийн дугаар
                </th>
                <td>
                  <input
                    v-model="bankAccount.task.langCode"
                    class="form-control"
                  />
                </td>
              </tr>
              <tr>
                <th scope="row" class="text-right">
                  Банкны нэр
                </th>
                <td>
                  <input v-model="bankAccount.task.st6" class="form-control" />
                </td>
              </tr>
              <tr>
                <th scope="row" class="text-right">
                  Дансны дугаар
                </th>
                <td>
                  <input
                    v-model="bankAccount.task.phone"
                    class="form-control"
                  />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <!-- modal-body -->
      <div class="modal-footer pd-x-20 pd-y-15">
        <button
          @click="bankAccount.modal = false"
          type="button"
          class="btn btn-white"
          data-dismiss="modal"
        >
          Болих
        </button>
        <button @click="postBankAccount" type="button" class="btn btn-primary">
          Илгээх
        </button>
      </div>
    </b-modal>

    <file-dialog
      :show="fileDialog.show"
      :id="fileDialog.id"
      @on-hide="fileDialog.show = false"
    />
  </div>
</template>
<script>
import AsyncLoadError from "@/components/base/asyncLoadingError";
import AsyncLoading from "@/components/base/asyncLoading";

import { request } from "@/api/all";
import { getDetailFields } from "@/api/taskCore";

import loader from "@/components/box/loader/loader.vue";

import "element-ui/lib/theme-chalk/index.css";
import { InputNumber, MessageBox, Notification } from "element-ui";

export default {
  components: {
    loader,
    InputNumber,
    MessageBox,
    taskInfo: () => ({
      component: import("@/components/task/detail/ot/components/info.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    fileDialog: () => ({
      component: import("@/components/modules/media/preview.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
    simpleUploader: () => ({
      component: import("@/components/modules/media/simpleUploader.vue"),
      loading: AsyncLoading,
      error: AsyncLoadError,
      delay: 100,
      timeout: 5000,
    }),
  },
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      ashigSonirhol: {
        attachmentTitle: null,
        attachmentId: null,
        secondAttachmentTitle: null,
        secondAttachmentId: null,
      },
      bankAccount: {
        isDone: false,
        modal: false,
        task: {
          //fifthAttachmentId: null
        },
      },
      agrmnt: {
        id: null,
        isDone: false,
        task: {
          //fifthAttachmentId: null
        },
        modal: false,
      },
      fileDialog: {
        id: null,
        show: false,
      },
      markObj: {
        fields: [],
        task: {
          b: [],
        },
        id: null,
        modal: false,
        fetched: false,
      },
      pointsDta: {
        points: [],
        projectTaskId: null,
        execution: null,
        isDone: false,
      },
      myResBaseUrl: "https://res.gosmart.mn/",
    };
  },
  created() {
    if (
      this.$store.state.app.activeGroup.resBaseUrl != undefined &&
      this.$store.state.app.activeGroup.resBaseUrl != ""
    ) {
      this.myResBaseUrl = this.$store.state.app.activeGroup.resBaseUrl;
    }
  },
  mounted() {
    request({
      api: { method: "GET", url: "task/TaskInheritedDetail" },
      params: { id: this.$store.state.user.userInfo.profileId },
      store: this.$store,
    }).then((res) => {
      this.toggleBodyClass("removeClass", "dynamic-locker");
      if (res != false) {
        this.bankAccount.task = res.data.task;
      }
    });
  },
  methods: {
    getDemjsenPoint(locTypeId) {
      if (locTypeId == 162060) return 28;
      else if (locTypeId == 162061) {
        return 21;
      } else if (locTypeId == 162066) {
        return 30;
      } else if (locTypeId == 162059) {
        return 21;
      } else if (locTypeId == 162063) {
        return 27;
      } else if (locTypeId == 200106) {
        return 21;
      } else if (locTypeId == 162062) {
        return 30;
      } else if (locTypeId == 162058) {
        return 21;
      }
    },
    postBankAccount() {
      request({
        api: { method: "POST", url: "Task/PostInherited" },
        data: { model: this.bankAccount.task },
        store: this.$store,
      }).then((res) => {
        if (res != false) {
          this.bankAccount.modal = false;
          this.postPoints(this.bankAccount.isDone);
        }
      });
    },
    dwnldM() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Media/FilePreviewDetail" },
        params: { id: 1168027 },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          // console.log(res.data.file)
          window.open(
            res.data.file.link + "?i=" + Math.floor(Math.random() * 100),
            "_blank"
          );
        }
      });
    },
    fileUploaded(e) {
      //console.log(e);
      this.ashigSonirhol.attachmentTitle = e.uploadedName;
      this.ashigSonirhol.attachmentId = e.uploadedAttachmentId;
    },
    fileUploaded2(e) {
      //console.log(e);
      //this.ashigSonirhol.secondAttachmentTitle = e.uploadedAttachmentId;
      this.ashigSonirhol.secondAttachmentTitle = e.uploadedName;
      this.ashigSonirhol.secondAttachmentId = e.uploadedAttachmentId;
    },

    checkBankAccount(id) {
      this.toggleBodyClass("addClass", "dynamic-locker");

      //
    },

    postAgrmnt() {
      if (
        this.ashigSonirhol.attachmentId > 0 &&
        this.ashigSonirhol.secondAttachmentId > 0
      ) {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "POST", url: "ProjectEdu/SetAshigSonirholAttach" },
          data: {
            taskId: this.agrmnt.id,
            attachmentId: this.ashigSonirhol.attachmentId,
            secondAttachmentId: this.ashigSonirhol.secondAttachmentId,
          },
          store: this.$store,
        }).then((res) => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          console.log("SetAshigSonirholAttach", res);
          if (res != false) {
            // console.log('1');
            this.agrmnt.modal = false;
            // console.log('2');
            this.pointsDta.attachId = this.ashigSonirhol.attachmentId;
            this.postPoints(this.agrmnt.isDone);
            // this.postPoints(true);
            //this.setMark(this.agrmnt.id);
          }
        });
      } else {
        Notification.warning({
          title: "Мэдэгдэл",
          message: `Бөглөсөн маягт файл сонгоогүй байна`,
          duration: 5000,
          position: "bottom-right",
        });
      }
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    setMark(id) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      getDetailFields({ params: { objectTypeId: 561 } }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.markObj.fields = res.data.fields;

          this.toggleBodyClass("addClass", "dynamic-locker");
          request({
            api: { method: "GET", url: "task/TaskInheritedDetail" },
            params: { id: id },
            store: this.$store,
          }).then((rest) => {
            this.toggleBodyClass("removeClass", "dynamic-locker");
            if (rest != false) {
              this.markObj.task = rest.data.task;
              //this.markObj.task.b.unshift({id: 0, nm: 'Ерөнхий мэдээлэл'});
              this.markObj.fetched = true;
              this.getMyPoints(id);
            }
          });
        }
      });
    },
    getMyPoints(id) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "ProjectEdu/GetMyPointsByProjectTaskId" },
        params: { projectTaskId: id },
        store: this.$store,
      }).then((res) => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.markObj.id = id;
          this.markObj.modal = true;
          this.pointsDta = res.data;

          // console.log('res', res);
        }
      });
    },
    showFile(e) {
      // console.log('e', e);
      //this.markObj.modal = false;
      this.fileDialog.id = e;
      this.fileDialog.show = true;
    },
    showDetail() {},
    loadBoxData() {},
    postPoints(isDone) {
      // console.log();
      // if(isDone!=undefined && isDone==true){
      //   this.pointsDta.isDone = true;
      // }else{
      //   this.pointsDta.isDone = true;
      // }
      this.pointsDta.isDone = isDone;
      if (this.pointsDta.attachId == null) {
        this.agrmnt.id = this.markObj.id;
        this.agrmnt.isDone = isDone;
        this.agrmnt.modal = true;
      } else {
        if (
          this.bankAccount.task.langCode == null ||
          this.bankAccount.task.langCode == "" ||
          this.bankAccount.task.st6 == null ||
          this.bankAccount.task.st6 == "" ||
          this.bankAccount.task.phone == null ||
          this.bankAccount.task.phone == ""
        ) {
          this.bankAccount.isDone = isDone;
          this.bankAccount.modal = true;
        } else {
          MessageBox.confirm(
            "Та үнэлгээг хадгалахдаа итгэлтэй байна уу ?",
            "Санамж",
            {
              confirmButtonText: "Тийм",
              cancelButtonText: "Үгүй",
              type: "warning",
            }
          )
            .then(() => {
              this.toggleBodyClass("addClass", "dynamic-locker");
              request({
                api: {
                  method: "POST",
                  url: "ProjectEdu/SetMyPointsByProjectTaskId",
                },
                data: this.pointsDta,
                store: this.$store,
              }).then((res) => {
                this.toggleBodyClass("removeClass", "dynamic-locker");
                if (res != false) {
                  //console.log("res", res);
                  if (isDone) {
                    Notification.info({
                      title: "Мэдэгдэл",
                      message: `Үр дүнг амжилттай хадгаллаа.`,
                      duration: 5000,
                      position: "bottom-right",
                    });
                  } else {
                    Notification.info({
                      title: "Мэдэгдэл",
                      message: `Тухайн шалгуур үзүүлэлтийн оноог амжилттай хадгаллаа.`,
                      duration: 5000,
                      position: "bottom-right",
                    });
                  }

                  this.$emit("on-reload");
                  this.markObj.modal = false;
                }
              });
            })
            .catch(() => {});
        }
      }
    },
  },
};
</script>

<style>
#markObj___BV_modal_outer_ {
  z-index: 5 !important;
}
.test-modal-body {
  /* width: calc(100% - 2rem);
    min-height: 100%;
    height: auto;
    margin: 1rem; */
  margin: 0;
  padding: 0;
}

.test-modal-dialog {
  max-width: 100%;
  margin: 0;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100vh;
  display: flex;
  position: fixed;
  z-index: 100000;
}
</style>
